<div
  class="lp-preview-shell"
  [class.is-active]="showMobilePreview"
  [style.--selected-theme-color]="selectedThemeColor"
>

  <!-- Desktop/tablet info banner (i18n) -->
  <div
    class="lp-preview-banner"
    *ngIf="showMobilePreview && !loading && !hasError"
    role="note"
    tabindex="0"
    [attr.dir]="isRtlLanguage ? 'rtl' : 'ltr'"
  >
    <div class="lp-preview-banner__header">
      <i nz-icon nzType="mobile" class="lp-preview-banner__icon" aria-hidden="true"></i>

      <div class="lp-preview-banner__title">
        {{ 'LANDING.DESKTOP_PREVIEW.TITLE' | translate }}
        <i
          nz-icon
          nzType="info-circle"
          class="lp-preview-banner__info"
          aria-hidden="true"
        ></i>
      </div>
    </div>

    <div class="lp-preview-banner__body">
      {{ 'LANDING.DESKTOP_PREVIEW.BODY' | translate }}
    </div>
  </div>
  <div
    #previewRoot
    class="page-container"
    [class.lp-device-frame]="showMobilePreview"
    [style.--selected-theme-color]="selectedThemeColor"
    [class.scanafy-bar-visible]="showBottomNav && appMode !== 'emergency' && mobileActiveTab === 'home' && !loading && !hasError"
    [class.has-floating-back]="showBottomNav && mobileActiveTab === 'info' && !!mobileInfoSectionId && !loading && !hasError"
    [class.is-mobile-info-dashboard]="showBottomNav && appMode !== 'emergency' && mobileActiveTab === 'info' && !mobileInfoSectionId"
    [class.no-bottom-nav]="showBottomNav && appMode === 'emergency'"
  >
    <div *ngIf="loading">
      <!-- Loading Spinner or Message -->
      <nz-spin nzTip="{{ 'COMPANY_PAGE.LOADING' | translate }}"></nz-spin>
    </div>
    <div
      *ngIf="!loading"
      class="lp-page-body"
      [class.lp-scroll-locked]="showMobilePreview && (notificationsDrawerOpen || showAnnouncementsPopup)"
    >
      <div *ngIf="hasError; else landingPageContent" class="error-page">
        <nz-result
          [nzStatus]="nzErrorStatus"
          [nzTitle]="getErrorTitle()"
          [nzSubTitle]="getErrorSubtitle()"
        >
          <div nz-result-extra>
            <button nz-button nzType="primary" (click)="reloadPage()">
              {{ 'COMPANY_PAGE.RETRY' | translate }}
            </button>
          </div>
        </nz-result>
      </div>
      <ng-template #landingPageContent>
        <!-- ===== Top bar: brand + announcements + language selector ===== -->
        <div class="lp-topbar">
          <!-- Left: brand name -->
          <div class="lp-topbar__brand">
            <span class="brand-name" *ngIf="company?.name">{{ company.name }}</span>
          </div>

          <!-- Flexible spacer keeps right-side items aligned -->
          <div class="lp-topbar__spacer"></div>

          <div class="lp-topbar__lang floating-language-selector" [attr.dir]="isRtlLanguage ? 'rtl' : 'ltr'">
            <div
              class="lp-language-dropdown"
              [class.open]="langDropdownOpen"
            >
              <button
                type="button"
                class="lp-language-trigger"
                (click)="toggleLanguageDropdown($event)"
                [attr.aria-expanded]="langDropdownOpen"
                aria-haspopup="listbox"
                [attr.aria-label]="'COMMON.SELECT_LANGUAGE' | translate"
              >
                <img
                  [src]="'assets/flags/4x3/' + getSelectedLanguageFlag() + '.svg'"
                  alt=""
                  width="20"
                  height="15"
                  class="lang-flag"
                  aria-hidden="true"
                />
                <span class="lp-language-trigger__label">{{ getSelectedLanguageLabel() }}</span>
                <span nz-icon nzType="down" nzTheme="outline" class="lp-language-trigger__chevron"></span>
              </button>

              <ng-template #technicalServiceCard let-service>
                <div class="ts-row">
                  <div class="ts-left">
                    <div class="ts-title" [ngStyle]="{ color: selectedThemeColor }">
                      <span
                        nz-icon
                        [nzType]="getServiceIcon(service.serviceType)"
                        [ngStyle]="{ color: selectedThemeColor }"
                        class="icon-theme service-icon"></span>
                      <span class="service-title">{{ getTranslatedServiceType(service.serviceType) }}</span>
                    </div>
                    <div class="ts-companies" *ngIf="service.companies?.length; else noCompany">
                      <ng-container *ngFor="let c of service.companies; let last = last">
                        <div class="ts-company-card">
                          <div class="ts-company-row">
                            <div class="ts-company-name">
                              {{ c.serviceName }}<span *ngIf="c.translatedServiceNote || c.serviceNote" class="ts-company-note"> {{ c.translatedServiceNote || c.serviceNote }}</span>
                            </div>
                            <div class="ts-company-contacts">
                              <div class="ts-phone" *ngIf="c.phone || !hasTechnicalServiceContactNumber(c)">
                                <span nz-icon nzType="phone" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                                <ng-container *ngIf="c.phone; else phoneNA">
                                  <a
                                    class="service-phone"
                                    [href]="'tel:' + c.phone"
                                    (click)="trackContactClick('phone', c.phone, 'technical-service', c.serviceName)"
                                    [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                                  >
                                    {{ formatGermanPhoneNumber(c.phone) }}
                                  </a>
                                </ng-container>
                                <ng-template #phoneNA>
                                  <span class="service-phone-empty">{{ 'COMMON.NA' | translate }}</span>
                                </ng-template>
                              </div>
                              <div class="ts-mobile" *ngIf="c.mobile">
                                <span nz-icon nzType="mobile" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                                <a
                                  class="service-phone"
                                  [href]="'tel:' + c.mobile"
                                  (click)="trackContactClick('mobile', c.mobile, 'technical-service', c.serviceName)"
                                  [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                                >
                                  {{ formatGermanPhoneNumber(c.mobile) }}
                                </a>
                              </div>
                              <div class="ts-emergency" *ngIf="c.emergencyNumber">
                                <span nz-icon nzType="alert" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                                <a
                                  class="service-phone"
                                  [href]="'tel:' + c.emergencyNumber"
                                  (click)="trackContactClick('mobile', c.emergencyNumber, 'technical-service', c.serviceName)"
                                  [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                                >
                                  {{ formatGermanPhoneNumber(c.emergencyNumber) }}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="ts-email" *ngIf="c.email">
                            <span nz-icon nzType="mail" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                            <a
                              class="service-email"
                              [href]="'mailto:' + c.email"
                              (click)="trackContactClick('email', c.email, 'technical-service', c.serviceName)"
                              [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                            >
                              {{ c.email }}
                            </a>
                          </div>
                        </div>
                        <div *ngIf="!last" class="ts-company-separator"></div>
                      </ng-container>
                    </div>
                    <ng-template #noCompany>
                      <div class="ts-company-row">
                        <div class="ts-company-name">{{ 'COMMON.NA' | translate }}</div>
                        <div class="ts-company-contacts">
                          <span class="service-phone-empty">{{ 'COMMON.NA' | translate }}</span>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </ng-template>

              <div
                class="lp-language-menu"
                *ngIf="langDropdownOpen"
                role="listbox"
                [attr.aria-label]="'COMMON.SELECT_LANGUAGE' | translate"
              >
                <button
                  type="button"
                  class="lp-language-option"
                  *ngFor="let lang of languages"
                  role="option"
                  [class.selected]="lang.value === selectedLanguage"
                  [attr.aria-selected]="lang.value === selectedLanguage"
                  (click)="selectLandingLanguage(lang.value, $event)"
                >
                  <img
                    [src]="'assets/flags/4x3/' + lang.flag + '.svg'"
                    alt=""
                    width="20"
                    height="15"
                    class="lang-flag"
                    aria-hidden="true"
                  />
                  <span class="lang-label">{{ lang.label }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- announcements bell with badge -->
          <div class="lp-topbar__notifications">
            <nz-badge
              [nzCount]="unreadAnnouncementsCount"
              [nzOverflowCount]="9"
              [nzShowZero]="false"
              [nzDot]="hasAnnouncements && !unreadAnnouncementsCount"
            >
              <button
                nz-button
                nzType="default"
                nzShape="circle"
                nzSize="small"
                class="lp-topbar__notifications-btn"
                [attr.aria-label]="'LANDING.ANNOUNCEMENTS.TITLE' | translate"
                (click)="onAnnouncementsIconClick()"
              >
                <i nz-icon nzType="bell"></i>
              </button>
            </nz-badge>
          </div>
        </div>
        <!-- ===== /Top bar ===== -->
        <!-- ===== Mobile announcements popup (first load, once per session) ===== -->
        <div
          class="lp-announcements-popup-backdrop"
          *ngIf="showAnnouncementsPopup"
          (click)="dismissAnnouncementsPopup()"
          [attr.dir]="isRtlLanguage ? 'rtl' : 'ltr'"
        >
          <div
            class="lp-announcements-popup"
            role="dialog"
            aria-modal="true"
            [attr.aria-label]="((unreadAnnouncementsCount === 1 ? 'LANDING.ANNOUNCEMENTS.POPUP_TITLE_ONE' : 'LANDING.ANNOUNCEMENTS.POPUP_TITLE_OTHER') | translate)"
            (click)="$event.stopPropagation()"
          >
            <button
              nz-button
              nzType="text"
              nzShape="circle"
              class="lp-announcements-popup__x"
              (click)="dismissAnnouncementsPopup()"
              [attr.aria-label]="'COMMON.CLOSE' | translate"
            >
              <i nz-icon nzType="close"></i>
            </button>

            <div class="lp-announcements-popup__icon" aria-hidden="true">
              <i nz-icon nzType="bell"></i>
            </div>

            <div class="lp-announcements-popup__count">
              {{ unreadAnnouncementsCount }}
            </div>

            <div
              class="lp-announcements-popup__context"
              *ngIf="property?.address || company?.name"
            >
              <i nz-icon [nzType]="property?.address ? 'environment' : 'home'"></i>
              <span>{{ property?.address || company?.name }}</span>
            </div>

            <div class="lp-announcements-popup__title">
              {{ (unreadAnnouncementsCount === 1 ? 'LANDING.ANNOUNCEMENTS.POPUP_TITLE_ONE' : 'LANDING.ANNOUNCEMENTS.POPUP_TITLE_OTHER') | translate }}
            </div>

            <div class="lp-announcements-popup__body">
              {{ (unreadAnnouncementsCount === 1 ? 'LANDING.ANNOUNCEMENTS.POPUP_BODY_ONE' : 'LANDING.ANNOUNCEMENTS.POPUP_BODY_OTHER') | translate:{ count: unreadAnnouncementsCount } }}
            </div>

            <div class="lp-announcements-popup__actions">
              <button
                nz-button
                nzType="primary"
                class="lp-announcements-popup__open"
                (click)="openAnnouncementsFromPopup()"
              >
                {{ (unreadAnnouncementsCount === 1 ? 'LANDING.ANNOUNCEMENTS.POPUP_OPEN_ONE' : 'LANDING.ANNOUNCEMENTS.POPUP_OPEN_OTHER') | translate }}
              </button>

              <button
                nz-button
                nzType="default"
                class="lp-announcements-popup__later"
                (click)="dismissAnnouncementsPopup()"
              >
                {{ 'LANDING.ANNOUNCEMENTS.POPUP_LATER' | translate }}
              </button>
            </div>
          </div>
        </div>
        <!-- ===== /Mobile announcements popup ===== -->
        <!-- ===== Mobile announcements nudge (shows when there are unread announcements) ===== -->
        <div
          class="lp-announcements-nudge"
          *ngIf="showAnnouncementsNudge"
          role="status"
          aria-live="polite"
        >
          <div class="lp-announcements-nudge__text">
            {{ (unreadAnnouncementsCount === 1 ? 'LANDING.ANNOUNCEMENTS.NUDGE_TEXT_ONE' : 'LANDING.ANNOUNCEMENTS.NUDGE_TEXT_OTHER') | translate:{ count: unreadAnnouncementsCount } }}
          </div>

          <button
            nz-button
            nzType="primary"
            nzSize="small"
            class="lp-announcements-nudge__open"
            (click)="openAnnouncementsFromNudge()"
          >
            {{ 'LANDING.ANNOUNCEMENTS.NUDGE_OPEN' | translate }}
          </button>

          <button
            nz-button
            nzType="text"
            nzSize="small"
            class="lp-announcements-nudge__close"
            (click)="dismissAnnouncementsNudge()"
            [attr.aria-label]="'COMMON.CLOSE' | translate"
          >
            <i nz-icon nzType="close"></i>
          </button>
        </div>
        <!-- ===== /Mobile announcements nudge ===== -->

        <div class="push-tip" *ngIf="showIosInstallTip">
          <span>{{ 'LANDING.ANNOUNCEMENTS.IOS_INSTALL' | translate }}</span>
          <div class="push-tip__actions">
            <button nz-button nzType="default" (click)="openIosInstallVideoModal()">
              {{ 'LANDING.ANNOUNCEMENTS.IOS_INSTALL_VIDEO' | translate }}
            </button>
            <button nz-button nzType="link" (click)="dismissIosTip()">{{ 'COMMON.GOT_IT' | translate }}</button>
          </div>
        </div>

        <div class="push-cta" *ngIf="showPushCta">
          <div class="cta-text">{{ 'LANDING.ANNOUNCEMENTS.PUSH_CTA' | translate }}</div>
          <div class="cta-actions">
            <button nz-button nzType="primary" (click)="enablePush()">{{ 'LANDING.ANNOUNCEMENTS.ENABLE' | translate }}</button>
            <button nz-button nzType="default" (click)="dismissPushCta()">{{ 'COMMON.DISMISS' | translate }}</button>
          </div>
        </div>

        <!-- Mobile-only: Info dashboard with section icons -->
        <div
          class="lp-mobile-info"
          *ngIf="showBottomNav && appMode !== 'emergency' && mobileActiveTab === 'info' && !mobileInfoSectionId">
          <div class="lp-mobile-info__title">
            {{ 'LANDING.NAV.INFO_DASHBOARD_TITLE' | translate }}
          </div>
          <!--                <div class="lp-mobile-info__hint" role="note">-->
          <!--                    <i nz-icon nzType="bulb" aria-hidden="true"></i>-->
          <!--                    <span>{{ 'LANDING.MOBILE_DASHBOARD.TAP_HINT' | translate }}</span>-->
          <!--                </div>-->
          <div class="lp-mobile-info__grid">
            <button
              type="button"
              class="lp-mobile-info__tile"
              *ngFor="let s of infoSectionMenu"
              [class.active]="mobileInfoSectionId === s.id"
              (click)="onMobileInfoSectionSelect(s.id)">
              <i nz-icon [nzType]="s.icon"></i>
              <span>{{ s.labelKey | translate }}</span>
            </button>
          </div>
          <!-- Featured primary action (mobile Info dashboard only) -->
          <button
            type="button"
            class="lp-mobile-info__featured"
            *ngIf="appMode === 'hospitality' && companyId && propertyId"
            (click)="openDigitalConcierge($event)"
            [attr.aria-label]="'HOSPITALITY_CHAT.BUBBLE_LABEL' | translate"
          >
            <div class="featured-icon" aria-hidden="true">
              <i nz-icon nzType="comment"></i>
            </div>

            <div class="featured-text">
              <div class="featured-title">{{ 'HOSPITALITY_CHAT.BUBBLE_LABEL' | translate }}</div>
              <div class="featured-subtitle">{{ 'LANDING.MOBILE_DASHBOARD.CONCIERGE_SUBTITLE' | translate }}</div>
            </div>

            <i nz-icon nzType="right" class="featured-chevron" aria-hidden="true"></i>
          </button>

        </div>

        <ng-container *ngIf="appMode === 'hospitality'; else emergencyLayout">
          <div class="hospitality-page"
               *ngIf="!showBottomNav || mobileActiveTab !== 'info' || !!mobileInfoSectionId"
               [style.--selected-theme-color]="selectedThemeColor"
          >

            <!-- Home content in hospitality (logo, welcome, guest note, address, quick actions) -->
            <ng-container *ngIf="!showBottomNav || mobileActiveTab === 'home'">
              <section [attr.id]="prefId('top')" class="hospitality-hero" *ngIf="hospitalityWelcomeMessage || hospitalityGuestNotes || company?.logoUrl || property?.address">
                <div class="hero-brand" *ngIf="company?.logoUrl || company?.name">
                  <img
                    [src]="company?.logoUrl || defaultLogoUrl"
                    (error)="company.logoUrl = defaultLogoUrl"
                    (load)="onLandingLogoLoad($event)"
                    alt="Company Logo"
                    class="hero-logo"
                    [class.hero-logo--tall]="isLogoTall"
                    [class.hero-logo--wide]="isLogoWide"
                  />
                  <div class="hero-meta">
                    <h1 *ngIf="hospitalityWelcomeMessage; else hospitalityDefaultTitle">{{ hospitalityWelcomeMessage }}</h1>
                    <ng-template #hospitalityDefaultTitle>
                      <h1>{{ 'LANDING.HOSPITALITY.WELCOME' | translate }}</h1>
                    </ng-template>
                    <p *ngIf="hospitalityGuestNotes" class="muted clamp-3">{{ hospitalityGuestNotes }}</p>
                  </div>
                </div>
                <div class="hero-address" *ngIf="property?.address">
                  <span nz-icon nzType="environment"></span>
                  <span>{{ property?.address }}</span>
                </div>
              </section>
              <!-- QUICK ACTIONS (paste right after </section> of .hospitality-hero) -->
              <section id="quick-actions" class="quick-actions"
                       *ngIf="hospitalityHostContact || hospitalityWifi || property?.address">
                <a *ngIf="hospitalityHostContact?.phone as phone"
                   nz-button nzType="primary" class="action-btn"
                   [href]="'tel:' + phone"
                   (click)="trackContactClick('phone', phone, 'hospitality-host', hospitalityHostContact?.name)">
                  <i nz-icon nzType="phone"></i>
                  <span>{{ 'LANDING.HOSPITALITY.CONTACT_HOST' | translate }}</span>
                </a>

                <a *ngIf="buildWhatsappLink(hospitalityHostContact?.whatsapp) as waLink"
                   nz-button nzType="default" class="action-btn"
                   [href]="waLink" target="_blank" rel="noopener"
                   (click)="trackHospitalityExternal('host-contact','whatsapp', waLink)">
                  <i nz-icon nzType="message"></i>
                  <span>WhatsApp</span>
                </a>

                <a *ngIf="property?.address"
                   nz-button nzType="default" class="action-btn"
                   [href]="getMapsLink(property.address)" target="_blank" rel="noopener"
                   (click)="trackHospitalityExternal('hero','maps', property.address)">
                  <i nz-icon nzType="environment"></i>
                  <span>{{ 'LANDING.HOSPITALITY.MAP' | translate }}</span>
                </a>
              </section>
            </ng-container>

            <div class="hospitality-grid">
              <section
                id="wifi"
                class="hospitality-card wifi-card"
                *ngIf="hospitalityWifi as wifi"
                [hidden]="!isHospitalitySectionVisible('wifi')"
              >
                <div class="card-title">
                  <i nz-icon nzType="wifi" class="icon-inline"></i>
                  <h2>{{ 'LANDING.HOSPITALITY.WIFI' | translate }}</h2>
                </div>

                <div class="wifi-grid">
                  <div *ngIf="wifi.networkName" class="wifi-row">
                    <span class="label">{{ 'LANDING.HOSPITALITY.WIFI_NETWORK' | translate }}</span>
                    <div class="value-row">
                      <code class="mono value clamp-1" title="{{ wifi.networkName }}">{{ wifi.networkName }}</code>
                      <button nz-button nzSize="small" (click)="copyToClipboard(wifi.networkName, 'wifi-ssid')">
                        <i nz-icon nzType="copy"></i>
                        <span [translate]="'COMMON.COPY'"></span>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="wifi.password" class="wifi-row">
                    <span class="label">{{ 'LANDING.HOSPITALITY.WIFI_PASSWORD' | translate }}</span>
                    <div class="value-row">
                      <code class="mono value clamp-1" title="{{ wifi.password }}">{{ wifi.password }}</code>
                      <button nz-button nzSize="small" (click)="copyToClipboard(wifi.password, 'wifi-password')">
                        <i nz-icon nzType="copy"></i>
                        <span [translate]="'COMMON.COPY'"></span>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="wifi.instructions" class="wifi-row">
                    <span class="label">{{ 'LANDING.HOSPITALITY.WIFI_INSTRUCTIONS' | translate }}</span>
                    <p class="muted clamp-3">{{ wifi.instructions }}</p>
                  </div>

                  <div *ngIf="wifi.supportContact" class="wifi-row">
                    <span class="label">{{ 'LANDING.HOSPITALITY.WIFI_SUPPORT' | translate }}</span>
                    <p class="muted clamp-2">{{ wifi.supportContact }}</p>
                  </div>
                </div>
              </section>

              <section
                id="host"
                class="hospitality-card host-card"
                *ngIf="hospitalityHostContact as hostContact"
                [hidden]="!isHospitalitySectionVisible('host')"
              >
                <h2>{{ 'LANDING.HOSPITALITY.CONTACT_SECTION_TITLE' | translate }}</h2>
                <p *ngIf="hostContact.name" class="host-name">{{ hostContact.name }}</p>
                <p *ngIf="hostContact.supportHours" class="host-hours">{{ hostContact.supportHours }}</p>
                <ul class="host-contact-list">
                  <li *ngIf="hostContact.phone as phone">
                    <a [href]="'tel:' + phone" (click)="trackContactClick('phone', phone, 'hospitality-host', hospitalityHostContact?.name)">
                      {{ formatGermanPhoneNumber(phone) }}
                    </a>
                  </li>

                  <li *ngIf="hostContact.email as email">
                    <a [href]="'mailto:' + email" (click)="trackContactClick('email', email, 'hospitality-host', hostContact.name)">
                      {{ email }}
                    </a>
                  </li>

                  <li *ngIf="buildWhatsappLink(hostContact.whatsapp) as waLink">
                    <a [href]="waLink"
                       target="_blank" rel="noopener"
                       (click)="trackHospitalityExternal('host-contact', 'whatsapp', waLink)">
                      {{ 'LANDING.HOSPITALITY.WHATSAPP' | translate }}
                    </a>
                  </li>
                </ul>
              </section>
            </div>

            <section
              id="timeline"
              class="hospitality-card timeline-card"
              *ngIf="hospitalityTimeline.length"
              [hidden]="!isHospitalitySectionVisible('timeline')"
            >
              <h2>{{ 'LANDING.HOSPITALITY.STAY_OVERVIEW' | translate }}</h2>
              <div class="timeline-items">
                <div class="timeline-item" *ngFor="let item of hospitalityTimeline">
                  <div class="timeline-header">
                    <i nz-icon [nzType]="item.type === 'check-in' ? 'login' : 'logout'"></i>
                    <h3>{{ item.titleKey | translate }}</h3>
                    <div class="chips">
                      <nz-tag *ngIf="item.from" nzColor="blue">
                        {{ 'LANDING.HOSPITALITY.FROM' | translate }}: {{ item.from }}
                      </nz-tag>
                      <nz-tag *ngIf="item.until" nzColor="geekblue">
                        {{ 'LANDING.HOSPITALITY.UNTIL' | translate }}: {{ item.until }}
                      </nz-tag>
                      <nz-tag *ngIf="item.location" nzColor="cyan" class="chip-click"
                              (click)="item.location && openMaps(item.location)">
                        <i nz-icon nzType="environment"></i>
                        {{ 'LANDING.HOSPITALITY.LOCATION' | translate }}
                      </nz-tag>
                    </div>
                  </div>

                  <div class="timeline-fields">
                    <div *ngIf="item.instructions">
                      <span class="label">{{ 'LANDING.HOSPITALITY.INSTRUCTIONS' | translate }}</span>
                      <p class="clamp-3">{{ item.instructions }}</p>
                    </div>

                    <div *ngIf="item.contact">
                      <span class="label">{{ 'LANDING.HOSPITALITY.CONTACT' | translate }}</span>
                      <p class="clamp-2">{{ item.contact }}</p>
                    </div>

                    <div *ngIf="item.links.length" class="link-list">
                      <span class="label">{{ 'LANDING.HOSPITALITY.LINKS' | translate }}</span>
                      <app-hospitality-link-preview
                        variant="list"
                        [links]="item.links | slice:0:3"
                        (linkClick)="trackHospitalityLink(item.type, $event)"
                      ></app-hospitality-link-preview>
                    </div>

                    <div *ngIf="item.digitalKeys.length" class="link-list digital-keys">
                      <span class="label">{{ 'LANDING.HOSPITALITY.DIGITAL_KEYS' | translate }}</span>
                      <ul>
                        <li *ngFor="let key of item.digitalKeys | slice:0:3" class="digital-key-entry">
                          <p class="digital-key-type">
                            <span class="digital-key-label">{{ 'LANDING.HOSPITALITY.DIGITAL_KEY_TYPE' | translate }}:</span>
                            <span>{{ key.typeLabel }}</span>
                          </p>
                          <p class="digital-key-primary">
                            <span class="digital-key-label">{{ key.primaryLabelKey | translate }}:</span>
                            <ng-container *ngIf="key.primaryLink; else digitalKeyPrimaryText">
                              <a [href]="key.primaryLink" target="_blank" rel="noopener"
                                 (click)="trackHospitalityLink(item.type, { label: key.typeLabel, url: key.primaryLink })">
                                {{ key.primaryLink }}
                              </a>
                            </ng-container>
                            <ng-template #digitalKeyPrimaryText>
                              <span>{{ key.primaryValue }}</span>
                            </ng-template>
                          </p>
                          <p *ngIf="key.notes" class="digital-key-notes muted">
                            <span class="digital-key-label">{{ (key.notesLabelKey || 'LANDING.HOSPITALITY.DIGITAL_KEY_NOTES') | translate }}:</span>
                            <span>{{ key.notes }}</span>
                          </p>
                          <p *ngIf="key.secondaryLink" class="digital-key-secondary">
                            <span class="digital-key-label">{{ (key.secondaryLinkLabelKey || 'LANDING.HOSPITALITY.DIGITAL_KEY_LINK') | translate }}:</span>
                            <a [href]="key.secondaryLink" target="_blank" rel="noopener"
                               (click)="trackHospitalityLink(item.type, { label: key.typeLabel, url: key.secondaryLink })">
                              {{ key.secondaryLink }}
                            </a>
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div *ngIf="item.checklist?.items?.length" class="checklist">
                      <span class="label">{{ item.checklist?.title || ('LANDING.HOSPITALITY.CHECKLIST' | translate) }}</span>
                      <ul>
                        <li *ngFor="let task of (showAllChecklist
                      ? (item.checklist?.items || [])
                      : ((item.checklist?.items || []) | slice:0:5))">
                          {{ task }}
                        </li>
                      </ul>
                      <button *ngIf="((item.checklist?.items?.length || 0) > 5)"
                              nz-button nzType="link" class="tiny-toggle"
                              (click)="showAllChecklist = !showAllChecklist"
                              [attr.aria-expanded]="showAllChecklist">
                        <i nz-icon [nzType]="showAllChecklist ? 'up' : 'down'"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              id="house-rules"
              class="hospitality-card house-rules-card"
              *ngIf="hospitalityHouseRules?.length"
              [hidden]="!isHospitalitySectionVisible('house-rules')"
            >
              <div class="card-title">
                <i nz-icon nzType="solution" class="icon-inline"></i>
                <h2>{{ 'LANDING.HOSPITALITY.HOUSE_RULES' | translate }}</h2>
              </div>

              <div
                class="house-rule-entry"
                *ngFor="let rule of (showAllRules ? hospitalityHouseRules : (hospitalityHouseRules | slice:0:6))"
              >
                <h3 *ngIf="rule.title">{{ rule.title }}</h3>
                <div *ngIf="rule.links?.length" class="link-list">
                  <span class="label">{{ 'LANDING.HOSPITALITY.LINKS' | translate }}</span>
                  <app-hospitality-link-preview
                    variant="list"
                    [links]="rule.links || []"
                    (linkClick)="trackHospitalityLink('house-rules', $event)"
                  ></app-hospitality-link-preview>
                </div>
              </div>

              <button *ngIf="(hospitalityHouseRules?.length || 0) > 6"
                      nz-button nzType="link" class="tiny-toggle"
                      (click)="showAllRules = !showAllRules"
                      [attr.aria-expanded]="showAllRules"
                      title="Toggle rules">
                <i nz-icon [nzType]="showAllRules ? 'up' : 'down'"></i>
              </button>
            </section>

            <section
              id="guides"
              class="hospitality-card guides-card"
              *ngIf="hospitalityGuides.length"
              [hidden]="!isHospitalitySectionVisible('guides')"
            >
              <h2>{{ 'LANDING.HOSPITALITY.APPLIANCE_GUIDES' | translate }}</h2>
              <nz-collapse nzBordered="false">
                <nz-collapse-panel *ngFor="let guide of hospitalityGuides; let i = index" [nzHeader]="guide.appliance || ('LANDING.HOSPITALITY.APPLIANCE_GUIDE' | translate)" [nzActive]="i === 0">
                  <p *ngIf="guide.summary">{{ guide.summary }}</p>
                  <ul *ngIf="guide.steps.length" class="guide-steps">
                    <li *ngFor="let step of guide.steps">{{ step }}</li>
                  </ul>
                  <div *ngIf="guide.resources.length" class="link-list">
                    <span class="label">{{ 'LANDING.HOSPITALITY.RESOURCES' | translate }}</span>
                    <app-hospitality-link-preview
                      variant="list"
                      [links]="guide.resources || []"
                      (linkClick)="trackHospitalityLink('appliance-guide', $event)"
                    ></app-hospitality-link-preview>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </section>

            <section
              id="local-tips"
              class="hospitality-card local-tips-card"
              *ngIf="hospitalityLocalTips as localTips"
              [hidden]="!isHospitalitySectionVisible('local-tips')"
            >
              <h2>{{ 'LANDING.HOSPITALITY.LOCAL_TIPS' | translate }}</h2>
              <p *ngIf="localTips.intro" class="muted">{{ localTips.intro }}</p>
              <div class="map-embed" *ngIf="localTips.mapMarkers?.length; else fallbackMap">
                <div
                  #localTipsMapContainer
                  class="map-canvas"
                  role="img"
                  [attr.aria-label]="'LANDING.HOSPITALITY.LOCAL_TIPS_MAP_ALT' | translate"
                ></div>
              </div>
              <ng-template #fallbackMap>
                <div class="map-embed" *ngIf="localTips.mapEmbedUrl">
                  <iframe [src]="localTips.mapEmbedUrl" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </ng-template>
              <a
                *ngIf="localTips.mapUrl"
                class="map-link"
                [href]="normalizeUrl(localTips.mapUrl)"
                target="_blank"
                rel="noopener"
                (click)="trackHospitalityExternal('local-tips', 'map', localTips.mapUrl)"
              >
                {{ 'LANDING.HOSPITALITY.MAP' | translate }}
              </a>
              <div class="map-attribution" *ngIf="localTips.mapMarkers?.length">
                {{ 'LANDING.HOSPITALITY.MAP_ATTRIBUTION' | translate }}
              </div>
              <div class="map-legend" *ngIf="localTips.mapMarkers?.length">
              <span class="map-legend__item">
                <span class="map-legend__swatch map-legend__swatch--property" aria-hidden="true"></span>
                {{ 'LANDING.HOSPITALITY.MAP_LEGEND_PROPERTY' | translate }}
              </span>
                <span class="map-legend__item">
                <span class="map-legend__swatch map-legend__swatch--highlight" aria-hidden="true"></span>
                  {{ 'LANDING.HOSPITALITY.MAP_LEGEND_HIGHLIGHT' | translate }}
              </span>
              </div>
              <div *ngIf="localTips.highlights.length" class="link-list">
                <span class="label">{{ 'LANDING.HOSPITALITY.HIGHLIGHTS' | translate }}</span>
                <app-hospitality-link-preview
                  variant="list"
                  [links]="localTips.highlights || []"
                  (linkClick)="trackHospitalityLink('local-tips', $event)"
                  [showSourceBadge]="true"
                ></app-hospitality-link-preview>
              </div>
            </section>

            <section
              id="feedback"
              class="hospitality-card feedback-card"
              *ngIf="hospitalityFeedback as feedback"
              [hidden]="!isHospitalitySectionVisible('feedback')"
            >
              <h2>{{ 'LANDING.HOSPITALITY.FEEDBACK' | translate }}</h2>
              <p *ngIf="feedback.instructions" class="muted clamp-2">{{ feedback.instructions }}</p>
              <div class="feedback-actions">
                <a
                  *ngIf="feedback.email as email"
                  [href]="'mailto:' + email"
                  class="feedback-link"
                  (click)="trackHospitalityFeedback('email', email)"
                >
                  {{ email }}
                </a>
                <a
                  *ngIf="feedback.phone as phone"
                  [href]="'tel:' + phone"
                  class="feedback-link"
                  (click)="trackHospitalityFeedback('phone', phone)"
                >
                  {{ formatGermanPhoneNumber(phone) }}
                </a>
                <a
                  *ngIf="feedback.formUrl as formUrl"
                  [href]="formUrl"
                  target="_blank"
                  rel="noopener"
                  class="feedback-button"
                  (click)="trackHospitalityFeedback('form', formUrl)"
                >
                  {{ 'LANDING.HOSPITALITY.FEEDBACK_FORM' | translate }}
                </a>
              </div>
            </section>

            <section
              id="info"
              class="hospitality-card info-card"
              *ngIf="hospitalityInfoSections.length"
              [hidden]="!isHospitalitySectionVisible('info')"
            >
              <h2>{{ 'LANDING.HOSPITALITY.INFO' | translate }}</h2>
              <div class="info-section" *ngFor="let info of hospitalityInfoSections">
                <h3 *ngIf="info.title">{{ info.title }}</h3>
                <p *ngIf="info.body" class="muted clamp-3">{{ info.body }}</p>
                <div *ngIf="info.links.length" class="link-list">
                  <app-hospitality-link-preview
                    variant="list"
                    [links]="info.links || []"
                    (linkClick)="trackHospitalityLink(info.key || 'info', $event)"
                    [showSourceBadge]="true"
                  ></app-hospitality-link-preview>
                </div>
              </div>
            </section>
            <div [attr.id]="prefId('docs')"
                 [hidden]="!isHospitalitySectionVisible(prefId('docs'))">
              <app-document-sections
                *ngIf="documentSections?.length || loadingDocs"
                [sections]="documentSections"
                [themeColor]="selectedThemeColor"
                [loading]="loadingDocs"
                [variant]="'hospitality'"
                (sectionView)="trackSectionView($event)"
                (documentView)="trackDocumentView($event.sectionTitle, $event.fileName)"
                (imagePreview)="openImagePreview($event)"
              ></app-document-sections>
            </div>

            <section
              id="rating"
              class="hospitality-card rating-card"
              *ngIf="showHospitalityRatingCard"
              [hidden]="!isHospitalitySectionVisible('rating')">
              <div class="card-title">
                <i nz-icon nzType="star" class="icon-inline"></i>
                <h2>{{ 'LANDING.HOSPITALITY.RATING_TITLE' | translate }}</h2>
              </div>
              <p class="muted clamp-3">{{ 'LANDING.HOSPITALITY.RATING_SUBTITLE' | translate }}</p>

              <div class="rating-summary" *ngIf="hospitalityRatingSummary as summary">
                <div class="summary-overall">
                  <span class="summary-score">{{ summary.overallAverage | number: '1.0-1' }}</span>
                  <span class="summary-label">{{ 'LANDING.HOSPITALITY.RATING_OVERALL' | translate }}</span>
                </div>
                <ul class="summary-breakdown">
                  <li *ngFor="let category of hospitalityRatingCategories">
                    <span class="label">{{ category.labelKey | translate }}</span>
                    <span class="value">{{ summary.averages[category.key] | number: '1.0-1' }}</span>
                  </li>
                </ul>
                <div class="summary-meta">
                  <span>{{ 'LANDING.HOSPITALITY.RATING_TOTAL' | translate:{ count: summary.count } }}</span>
                  <span *ngIf="summary.lastSubmittedAt">
                  {{ 'LANDING.HOSPITALITY.RATING_LAST_SUBMITTED' | translate }}:
                    {{ summary.lastSubmittedAt | date:'mediumDate':undefined:selectedLanguage }}
                </span>
                </div>
              </div>

              <div class="rating-form" *ngIf="!hospitalityRatingSubmitted">
                <div class="rating-row" *ngFor="let category of hospitalityRatingCategories">
                  <label>{{ category.labelKey | translate }}</label>
                  <nz-rate
                    [nzAllowClear]="false"
                    [(ngModel)]="hospitalityRatingScores[category.key]"
                    (ngModelChange)="onHospitalityRatingChange()"
                  ></nz-rate>
                </div>
                <p class="error" *ngIf="hospitalityRatingError">{{ hospitalityRatingError }}</p>
                <button
                  nz-button
                  nzType="primary"
                  (click)="submitHospitalityRating()"
                  [disabled]="hospitalityRatingSubmitting"
                  [nzLoading]="hospitalityRatingSubmitting"
                >
                  {{ 'LANDING.HOSPITALITY.RATING_SUBMIT' | translate }}
                </button>
              </div>

              <div class="rating-confirmation" *ngIf="hospitalityRatingSubmitted">
                <p>{{ hospitalityRatingSuccess || ('LANDING.HOSPITALITY.RATING_THANK_YOU' | translate) }}</p>
              </div>
            </section>

            <div
              class="hospitality-empty"
              *ngIf="showHospitalityEmptyState"
            >
              {{ 'LANDING.HOSPITALITY.NO_INFORMATION' | translate }}
            </div>
          </div>
        </ng-container>
        <ng-template #emergencyLayout>
          <div class="company-page-container">

            <div class="flyer-section"
                 *ngIf="!showBottomNav || appMode !== 'emergency' || !mobileInfoSectionId || hasVisibleFlyerContentOnMobileInfo"
                 [attr.id]="prefId('top')"
                 [class.is-empty]="!hasVisibleFlyerContentOnMobileInfo"
                 [class.is-mobile-info]="showBottomNav && appMode === 'emergency' && !!mobileInfoSectionId"
                 [class.is-mobile-home]="showBottomNav && appMode === 'emergency' && !mobileInfoSectionId"
                 [ngClass]="{ 'has-border': showFlyerBorder || (showBottomNav && appMode === 'emergency' && !mobileInfoSectionId) }">
              <!-- Header Section -->
              <div class="header-section" [hidden]="showBottomNav && appMode === 'emergency'">
                <div
                  class="logo-container"
                  [class.logo-container--tall]="isEmergencyLogoTall"
                  [class.logo-container--wide]="isEmergencyLogoWide"
                >
                  <img
                    [src]="company?.logoUrl || defaultLogoUrl"
                    (error)="company.logoUrl = defaultLogoUrl"
                    (load)="onEmergencyLogoLoad($event)"
                    alt="Company Logo"
                    class="company-logo-img"
                  />
                </div>
                <div class="header-text">
                  <h2 class="header-title" [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.WE_ARE_HERE' | translate }}</h2>
                  <p class="sub-header">{{ 'COMPANY_PAGE.OUR_SERVICE_NUMBERS' | translate }}</p>
                </div>
              </div>

              <!-- Display Caretaker Text -->
              <div
                id="caretaker-text"
                class="caretaker-text"
                *ngIf="company?.caretakerText && shouldShowCaretakerText()">
                <p>{{ translatedCaretakerText || company?.caretakerText }}</p>
              </div>

              <!-- Caretaker Information -->
              <div
                id="caretaker"
                class="caretaker-info-section"
                [hidden]="!isEmergencySectionVisible('caretaker')"
                *ngIf="caretaker"
              >
                <div class="caretaker-details">
                  <h3 style="text-align: center">{{ 'COMPANY_PAGE.YOUR_CARETAKER' | translate }}</h3>


                  <div class="detail-item">
                    <span nz-icon nzType="user" nzTheme="outline" class="icon-white"></span>
                    <p class="caretaker-name">{{ caretaker?.name }}</p>
                  </div>

                  <div class="detail-item" *ngIf="caretaker?.address">
                    <span nz-icon nzType="environment" nzTheme="outline" class="icon-white"></span>
                    <p>{{ caretaker?.address }}</p>
                  </div>
                  <div class="detail-item" *ngIf="caretaker?.email">
                    <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                    <a href="mailto:{{ caretaker?.email }}" (click)="trackContactClick('email', caretaker?.email, 'caretaker', caretaker?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ caretaker?.email }}</a>
                  </div>
                  <div class="detail-item">
                    <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                    <a href="tel:{{ caretaker?.phone }}" (click)="trackContactClick('phone', caretaker?.phone, 'caretaker', caretaker?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(caretaker?.phone) }}</a>
                  </div>
                  <div class="detail-item" *ngIf="caretaker?.mobile">
                    <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                    <a href="tel:{{ caretaker?.mobile }}" (click)="trackContactClick('mobile', caretaker?.mobile, 'caretaker', caretaker?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(caretaker?.mobile) }}</a>
                  </div>
                  <div class="detail-item" *ngIf="caretaker?.emergencyNumber">
                    <span nz-icon nzType="alert" nzTheme="outline" class="icon-white"></span>
                    <a href="tel:{{ caretaker?.emergencyNumber }}" (click)="trackContactClick('phone', caretaker?.emergencyNumber, 'caretaker', caretaker?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ 'CONTACTS.EMERGENCY_NUMBER' | translate }}: {{ formatGermanPhoneNumber(caretaker?.emergencyNumber) }}</a>
                  </div>
                  <div class="detail-item" *ngIf="caretaker?.note">
                    <span nz-icon nzType="info-circle" nzTheme="outline" class="icon-white"></span>
                    <p class="note-text">{{ translatedCaretakerNote || caretaker?.note }}</p>
                  </div>
                  <div class="detail-item" *ngIf="caretakerFormattedAvailability?.length">
                    <div class="company-availability" style="width: 100%;">
                      <div class="availability-card" *ngFor="let group of caretakerFormattedAvailability" style="margin-bottom: 10px;">
                        <div class="day-info">
                          <i nz-icon nzType="calendar" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                          <strong>{{ group.days }}</strong>
                        </div>

                        <div class="time-info">
                          <i nz-icon nzType="clock-circle" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                          <span class="time-chip">{{ group.startTime }} - {{ group.endTime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section class="caretaker-contact-persons" *ngIf="caretakerContactPersons.length">
                    <h4 class="caretaker-contact-persons__title">
                      {{ caretakerContactPersonCountKey() | translate:{ count: caretakerContactPersons.length } }}
                    </h4>
                    <article class="caretaker-contact-person" *ngFor="let person of caretakerContactPersons">
                      <div class="detail-item">
                        <span nz-icon nzType="contacts" nzTheme="outline" class="icon-white"></span>
                        <p class="caretaker-name">{{ person.name }}</p>
                      </div>
                      <div class="detail-item" *ngIf="person.position">
                        <span nz-icon nzType="idcard" nzTheme="outline" class="icon-white"></span>
                        <p>{{ person.position }}</p>
                      </div>
                      <div class="detail-item" *ngIf="person.phone">
                        <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                        <a [href]="'tel:' + getCaretakerContactDialNumber(person.phone)" (click)="trackContactClick('phone', person.phone, 'caretaker', getCaretakerContactTrackingName(person))" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(person.phone) }}</a>
                      </div>
                      <div class="detail-item" *ngIf="person.mobile">
                        <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                        <a [href]="'tel:' + getCaretakerContactDialNumber(person.mobile)" (click)="trackContactClick('mobile', person.mobile, 'caretaker', getCaretakerContactTrackingName(person))" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(person.mobile) }}</a>
                      </div>
                      <div class="detail-item" *ngIf="person.email">
                        <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                        <a [href]="'mailto:' + person.email" (click)="trackContactClick('email', person.email, 'caretaker', getCaretakerContactTrackingName(person))" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ person.email }}</a>
                      </div>
                    </article>
                  </section>

                </div>
              </div>

              <!-- Property Address Section -->
              <div id="address" class="contact-info-section"
                   [hidden]="!(isEmergencySectionVisible('address') || (showBottomNav && appMode === 'emergency' && !mobileInfoSectionId))">
                <div class="address-header">
                  <img
                    *ngIf="showBottomNav && appMode === 'emergency' && !mobileInfoSectionId"
                    [src]="company?.logoUrl || defaultLogoUrl"
                    (error)="company.logoUrl = defaultLogoUrl"
                    (load)="onEmergencyLogoLoad($event)"
                    alt="Company Logo"
                    class="company-logo-img"
                    [class.company-logo-img--wide]="isEmergencyLogoWide"
                    [class.company-logo-img--tall]="isEmergencyLogoTall"
                  />
                  <h3 [ngStyle]="{ 'color': selectedThemeColor }">
                    {{ 'COMPANY_PAGE.PROPERTY_ADDRESS' | translate }}
                  </h3>
                </div>

                <div class="address-item">
                  <ul>
                    <li>
                      <span nz-icon nzType="environment" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      {{ property?.address }}
                    </li>
                  </ul>
                </div>
              </div>
              <div id="contact" class="contact-info-section"
                   [hidden]="!(isEmergencySectionVisible('contact') || (showBottomNav && appMode === 'emergency' && !mobileInfoSectionId))">
                <h3 [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.HOW_TO_REACH_US' | translate }}</h3>
                <ng-container *ngIf="howToReachUsManagers?.length && !mobileInfoSectionId; else companyContactFallback">
                  <ul>
                    <li *ngIf="company?.name">
                      <span nz-icon nzType="home" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      <span>{{ company?.name }}</span>
                    </li>
                    <ng-container *ngFor="let manager of howToReachUsManagers; let isFirst = first">
                      <li *ngIf="!isFirst" class="how-to-reach-us-manager-separator"></li>
                      <li class="how-to-reach-us-manager-name">
                        <div class="how-to-reach-us-manager-name-row">
                          <span nz-icon nzType="user" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                          <span>{{ manager?.name }}</span>
                        </div>
                        <small class="how-to-reach-us-manager-role-badge">{{ 'COMPANY_PAGE.' + getManagerTypeLabelKey(manager?.managerType) | translate }}</small>
                      </li>
                      <li *ngIf="manager?.phone">
                        <span nz-icon nzType="phone" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a href="tel:{{ manager?.phone }}" (click)="trackContactClick('phone', manager.phone, manager?.managerType, manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(manager?.phone) }}</a>
                      </li>
                      <li *ngIf="manager?.mobile">
                        <span nz-icon nzType="mobile" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a href="tel:{{ manager?.mobile }}" (click)="trackContactClick('mobile', manager.mobile, manager?.managerType, manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(manager?.mobile) }}</a>
                      </li>
                      <li *ngIf="manager?.email">
                        <span nz-icon nzType="mail" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a href="mailto:{{ manager?.email }}" (click)="trackContactClick('email', manager.email, manager?.managerType, manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ manager?.email }}</a>
                      </li>
                    </ng-container>
                  </ul>
                </ng-container>
                <ng-template #companyContactFallback>
                  <ng-container *ngIf="company?.name || company?.phone || company?.whatsappNumber || isNonEmpty(company?.displayEmail) || company?.website || company?.address; else noContactsCompany">
                    <ul>
                      <li *ngIf="company?.name">
                        <span nz-icon nzType="home" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <span>{{ company?.name }}</span>
                      </li>
                      <li *ngIf="company?.address">
                        <span nz-icon nzType="environment" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        {{ company?.address }}
                      </li>
                      <li>
                        <span nz-icon nzType="phone" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a href="tel:{{ company?.phone }}" (click)="trackContactClick('phone', company?.phone, 'company', company?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(company?.phone) }}</a>
                      </li>
                      <li *ngIf="buildWhatsappLink(company?.whatsappNumber, false) as whatsappLink">
                        <span nz-icon nzType="message" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a
                          [href]="whatsappLink"
                          target="_blank"
                          rel="noopener noreferrer"
                          [attr.aria-label]="('LANDING.HOSPITALITY.WHATSAPP' | translate) + ': ' + company?.whatsappNumber"
                          (click)="trackContactClick('whatsapp', company?.whatsappNumber, 'company', company?.name)"
                          [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                        >
                          {{ 'LANDING.HOSPITALITY.WHATSAPP' | translate }}: {{ company?.whatsappNumber }}
                        </a>
                      </li>
                      <li *ngIf="isNonEmpty(company?.displayEmail)">
                        <span nz-icon nzType="mail" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a
                          href="mailto:{{ company?.displayEmail }}"
                          (click)="trackContactClick('email', company?.displayEmail, 'company', company?.name)"
                          [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                        >
                          {{ company?.displayEmail }}
                        </a>
                      </li>
                      <li *ngIf="company?.website">
                        <span nz-icon nzType="global" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                        <a [href]="normalizeUrl(company.website)" target="_blank" rel="noopener noreferrer">
                          {{ company.website }}
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                  <ng-template #noContactsCompany>
                    <p>{{ 'LANDING.EMPTY.CONTACTS' | translate }}</p>
                  </ng-template>
                </ng-template>
              </div>

              <!-- Property Managers -->
              <div
                id="property-managers"
                class="property-info-section"
                [hidden]="!isEmergencySectionVisible('property-managers')"
                *ngIf="company?.showPropertyManager && (propertyManagers?.length || 0) > 0"
              >
                <div class="caretaker-details">
                  <h3 style="text-align: center">{{ 'PROPERTY_LIST.LANDING_PAGE_PROPERTY_MANAGER' | translate }}</h3>

                  <div *ngFor="let manager of propertyManagers">
                    <div class="detail-item">
                      <span nz-icon nzType="user" nzTheme="outline" class="icon-white"></span>
                      <p>{{ manager?.name }}</p>
                    </div>

                    <div class="detail-item" *ngIf="manager?.email">
                      <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                      <a href="mailto:{{ manager?.email }}" (click)="trackContactClick('email', manager.email, 'property-manager', manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ manager?.email }}</a>
                    </div>

                    <div class="detail-item" *ngIf="manager?.phone">
                      <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                      <a href="tel:{{ manager?.phone }}" (click)="trackContactClick('phone', manager.phone, 'property-manager', manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(manager?.phone) }}</a>
                    </div>
                    <div class="detail-item" *ngIf="manager?.mobile">
                      <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                      <a
                        href="tel:{{ manager?.mobile }}"
                        (click)="trackContactClick('mobile', manager.mobile, 'property-manager', manager?.name)"
                        [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                      >
                        {{ formatGermanPhoneNumber(manager?.mobile) }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Technical Assets Managers -->
              <div
                id="technical-assets-managers"
                class="caretaker-info-section"
                [hidden]="!isEmergencySectionVisible('technical-assets-managers')"
                *ngIf="company?.showTechnicalAssetsManager && (technicalAssetsManagers?.length || 0) > 0"
              >
                <div class="caretaker-details">
                  <h3 style="text-align: center">{{ 'PROPERTY_LIST.LANDING_PAGE_TECHNICAL_ASSETS_MANAGER' | translate }}</h3>

                  <div *ngFor="let tam of technicalAssetsManagers">
                    <div class="detail-item">
                      <span nz-icon nzType="user" nzTheme="outline" class="icon-white"></span>
                      <p>{{ tam?.name }}</p>
                    </div>
                    <div class="detail-item" *ngIf="tam?.email">
                      <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                      <a href="mailto:{{ tam?.email }}" (click)="trackContactClick('email', tam.email, 'technical-assets-manager', tam?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ tam?.email }}</a>
                    </div>
                    <div class="detail-item" *ngIf="tam?.phone">
                      <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                      <a href="tel:{{ tam?.phone }}" (click)="trackContactClick('phone', tam.phone, 'technical-assets-manager', tam?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(tam?.phone) }}</a>
                    </div>
                    <div class="detail-item" *ngIf="tam?.mobile">
                      <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                      <a
                        href="tel:{{ tam?.mobile }}"
                        (click)="trackContactClick('mobile', tam.mobile, 'technical-assets-manager', tam?.name)"
                        [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                      >
                        {{ formatGermanPhoneNumber(tam?.mobile) }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="sev-managers"
                class="caretaker-info-section"
                [hidden]="!isEmergencySectionVisible('sev-managers')"
                *ngIf="company?.showSevManager && (sevManagers?.length || 0) > 0"
              >
                <div class="caretaker-details">
                  <h3 style="text-align: center">{{ 'PROPERTY_LIST.LANDING_PAGE_CONDOMINIUM_MANAGER' | translate }}</h3>

                  <div *ngFor="let manager of sevManagers">
                    <div class="detail-item">
                      <span nz-icon nzType="user" nzTheme="outline" class="icon-white"></span>
                      <p>{{ manager?.name }}</p>
                    </div>
                    <div class="detail-item" *ngIf="manager?.email">
                      <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                      <a href="mailto:{{ manager?.email }}" (click)="trackContactClick('email', manager.email, 'sev-manager', manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ manager?.email }}</a>
                    </div>
                    <div class="detail-item" *ngIf="manager?.phone">
                      <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                      <a href="tel:{{ manager?.phone }}" (click)="trackContactClick('phone', manager.phone, 'sev-manager', manager?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(manager?.phone) }}</a>
                    </div>
                    <div class="detail-item" *ngIf="manager?.mobile">
                      <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                      <a
                        href="tel:{{ manager?.mobile }}"
                        (click)="trackContactClick('mobile', manager.mobile, 'sev-manager', manager?.name)"
                        [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                      >
                        {{ formatGermanPhoneNumber(manager?.mobile) }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="accountants"
                class="caretaker-info-section"
                [hidden]="!isEmergencySectionVisible('accountants')"
                *ngIf="company?.showAccountant && (accountants?.length || 0) > 0"
              >
                <div class="caretaker-details">
                  <h3 style="text-align: center">{{ 'PROPERTY_LIST.LANDING_PAGE_ACCOUNTANT' | translate }}</h3>

                  <div *ngFor="let accountant of accountants">
                    <div class="detail-item">
                      <span nz-icon nzType="user" nzTheme="outline" class="icon-white"></span>
                      <p>{{ accountant?.name }}</p>
                    </div>
                    <div class="detail-item" *ngIf="accountant?.email">
                      <span nz-icon nzType="mail" nzTheme="outline" class="icon-white"></span>
                      <a href="mailto:{{ accountant?.email }}" (click)="trackContactClick('email', accountant.email, 'accountant', accountant?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ accountant?.email }}</a>
                    </div>
                    <div class="detail-item" *ngIf="accountant?.phone">
                      <span nz-icon nzType="phone" nzTheme="outline" class="icon-white"></span>
                      <a href="tel:{{ accountant?.phone }}" (click)="trackContactClick('phone', accountant.phone, 'accountant', accountant?.name)" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(accountant?.phone) }}</a>
                    </div>
                    <div class="detail-item" *ngIf="accountant?.mobile">
                      <span nz-icon nzType="mobile" nzTheme="outline" class="icon-white"></span>
                      <a
                        href="tel:{{ accountant?.mobile }}"
                        (click)="trackContactClick('mobile', accountant.mobile, 'accountant', accountant?.name)"
                        [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                      >
                        {{ formatGermanPhoneNumber(accountant?.mobile) }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Unified 'no contacts' message for managers (shown only on mobile + emergency when none exist) -->
              <div class="contact-info-section" *ngIf="showUnifiedNoContacts">
                <p>{{ 'LANDING.EMPTY.CONTACTS' | translate }}</p>
              </div>
              <ng-container *ngIf="hasAnyAvailability || hasAnyEmergencyAvailability">
                <!-- Company Availability Service Information -->
                <div id="availability" class="emergency-info-section" *ngIf="hasAnyAvailability"
                     [hidden]="!isEmergencySectionVisible('availability')">
                  <h3 [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.COMPANY_AVAILABILITY' | translate }}</h3>

                  <div class="company-availability">
                    <!--          <h4 [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.COMPANY_AVAILABILITY' | translate }}</h4>-->

                    <div class="availability-card" *ngFor="let group of formattedAvailability" style="margin-bottom: 10px;">
                      <div class="day-info">
                        <i nz-icon nzType="calendar" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                        <strong>{{ group.daysLabel }}</strong>
                      </div>

                      <div class="time-info">
                        <i nz-icon nzType="clock-circle" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                        <ng-container *ngFor="let t of group.times; let last = last">
                          <span class="time-chip">{{ t.startTime }} - {{ t.endTime }}</span>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Company Emergency Availability Service Information -->
                <div id="emergency-availability" class="emergency-info-section" *ngIf="hasAnyEmergencyAvailability"
                     [hidden]="!isEmergencySectionVisible('emergency-availability')">
                  <h3 [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.EMERGENCY_SERVICE' | translate }}</h3>
                  <p>
                    <i nz-icon nzType="alert" [ngStyle]="{'color': company?.themeColor}"></i>
                    <a href="tel:{{ company?.emergencyNumber }}" (click)="trackEmergencyCall()" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">{{ formatGermanPhoneNumber(company?.emergencyNumber) }}</a>
                  </p>

                  <p class="emergency-note">{{ 'COMPANY_PAGE.EMERGENCY_CASES_DESCRIPTION' | translate }}</p>
                  <div class="company-availability">
                    <h4 [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.COMPANY_EMERGENCY_AVAILABILITY' | translate }}</h4>

                    <div class="availability-card" *ngFor="let group of formattedEmergencyAvailability" style="margin-bottom: 10px;">
                      <div class="day-info">
                        <i nz-icon nzType="calendar" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                        <strong>{{ group.daysLabel }}</strong>
                      </div>
                      <div class="time-info">
                        <i nz-icon nzType="clock-circle" class="icon" [ngStyle]="{'color': company?.themeColor}"></i>
                        <ng-container *ngFor="let t of group.times">
                          <span class="time-chip">{{ t.startTime }} - {{ t.endTime }}</span>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div
                id="emergency-numbers"
                class="emergency-number-section"
                *ngIf="hasVisibleEmergencyNumbers"
                [hidden]="!isEmergencySectionVisible('emergency-numbers')">
                <h3 [ngStyle]="{ 'color': selectedThemeColor }">
                  {{ 'COMPANY_PAGE.EMERGENCY_NUMBERS_TITLE' | translate }}
                </h3>
                <ng-container *ngIf="hasVisibleEmergencyNumbers; else noEmergencyNums">
                  <!-- the lane that centers as a block but left-aligns its content -->
                  <div class="emergency-number-list">
                    <div class="emergency-number-item" *ngIf="showEmergencyNumber112">
                      <span nz-icon nzType="fire" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      <div class="emergency-number-text">
                        <span class="emergency-number-label">
                          {{ 'COMPANY_PAGE.EMERGENCY_NUMBER_112_LABEL' | translate }}
                        </span>
                        <a href="tel:112" (click)="trackEmergencyCall()" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">112</a>
                      </div>
                    </div>

                    <div class="emergency-number-item" *ngIf="showEmergencyNumber110">
                      <span nz-icon nzType="safety-certificate" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      <div class="emergency-number-text">
                        <span class="emergency-number-label">
                          {{ 'COMPANY_PAGE.EMERGENCY_NUMBER_110_LABEL' | translate }}
                        </span>
                        <a href="tel:110" (click)="trackEmergencyCall()" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">110</a>
                      </div>
                    </div>

                    <div class="emergency-number-item" *ngIf="showEmergencyNumber116117">
                      <span nz-icon nzType="medicine-box" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      <div class="emergency-number-text">
                        <span class="emergency-number-label">
                          {{ 'COMPANY_PAGE.EMERGENCY_NUMBER_116117_LABEL' | translate }}
                        </span>
                        <a href="tel:116117" (click)="trackEmergencyCall()" [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }">116 117</a>
                      </div>
                    </div>

                    <div class="emergency-number-item" *ngFor="let hotline of additionalEmergencyHotlines; trackBy: trackEmergencyHotline">
                      <span nz-icon [nzType]="hotline.icon" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                      <div class="emergency-number-text">
                        <span class="emergency-number-label">
                          {{ hotline.labelKey | translate }}
                        </span>
                        <a
                          [href]="'tel:' + getEmergencyHotlineDialNumber(hotline.number)"
                          (click)="trackEmergencyCall()"
                          [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                        >
                          {{ hotline.number }}
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="technical-service-section emergency-service-contacts" *ngIf="emergencyTechnicalServices.length">
                    <h4 [ngStyle]="{ 'color': selectedThemeColor }">
                      {{ 'LANDING.ADDITIONAL_EMERGENCY_CONTACTS' | translate }}
                    </h4>
                    <div class="ts-group">
                      <ng-container *ngFor="let service of emergencyTechnicalServices">
                        <ng-container
                          [ngTemplateOutlet]="technicalServiceCard"
                          [ngTemplateOutletContext]="{ $implicit: service }"
                        ></ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noEmergencyNums>
                  <p>{{ 'LANDING.EMPTY.EMERGENCY_NUMBERS' | translate }}</p>
                </ng-template>
              </div>
            </div>

            <section
              *ngIf="shouldShowPublicLandingPageMessage()"
              class="lp-public-notice"
              role="note"
            >
              <span
                nz-icon
                nzType="info-circle"
                nzTheme="outline"
                class="lp-public-notice__icon"
                aria-hidden="true"
              ></span>
              <div class="lp-public-notice__text">{{ translatedPublicLandingPageMessage || publicLandingPageMessage }}</div>
            </section>

            <!-- Emergency mobile hub: feature cards under the company card (bottom tabs removed) -->
            <div
              class="lp-mobile-info lp-emergency-hub"
              *ngIf="showBottomNav && appMode === 'emergency' && !mobileInfoSectionId && infoSectionMenu.length > 0"
            >
              <div class="lp-mobile-info__title">
                {{ 'LANDING.MOBILE_DASHBOARD.SECTION_TITLE' | translate }}
              </div>
              <!--                        <div class="lp-mobile-info__hint" role="note">-->
              <!--                            <i nz-icon nzType="bulb" aria-hidden="true"></i>-->
              <!--                            <span>{{ 'LANDING.MOBILE_DASHBOARD.TAP_HINT' | translate }}</span>-->
              <!--                        </div>-->
              <div class="lp-mobile-info__grid">
                <button
                  type="button"
                  class="lp-mobile-info__tile"
                  *ngFor="let s of infoSectionMenu"
                  (click)="onMobileInfoSectionSelect(s.id)"
                >
                  <i nz-icon [nzType]="s.icon"></i>
                  <span>{{ s.labelKey | translate }}</span>
                </button>
              </div>
            </div>
            <!-- Emergency Instructions -->
            <div
              id="emergency-instructions"
              class="emergency-instructions-section"
              *ngIf="appMode === 'emergency' && (emergencyInstructionsLoading || emergencyInstructionsError || (emergencyInstructions?.length))"
              [hidden]="!isEmergencySectionVisible('emergency-instructions')"
              [attr.dir]="isRtlLanguage ? 'rtl' : 'ltr'"
            >
              <div class="emergency-instructions-header">

                <div class="emergency-instructions-header__text">
                  <h2 [ngStyle]="{ 'color': selectedThemeColor }">
                    {{ 'LANDING.EMERGENCY_INSTRUCTIONS.TITLE' | translate }}
                  </h2>
                </div>
              </div>

              <ng-container *ngIf="emergencyInstructionsLoading; else emergencyInstructionsLoaded">
                <nz-spin nzTip="{{ 'LANDING.EMERGENCY_INSTRUCTIONS.LOADING' | translate }}"></nz-spin>
              </ng-container>

              <ng-template #emergencyInstructionsLoaded>
                <div class="instructions-error" *ngIf="emergencyInstructionsError">
                  {{ 'LANDING.EMERGENCY_INSTRUCTIONS.ERROR' | translate }}
                </div>

                <nz-collapse
                  *ngIf="!emergencyInstructionsError && (emergencyInstructions?.length)"
                  nzBordered="false"
                  nzAccordion
                  class="instructions-collapse"
                >
                  <nz-collapse-panel
                    *ngFor="let item of emergencyInstructions; let i = index"
                    [nzHeader]="headerTpl"
                    [nzActive]="i === 0"
                    (nzActiveChange)="onEmergencyInstructionActiveChange($event, item, i)"
                  >
                    <ng-template #headerTpl>
                      <span
                        nz-icon
                        [nzType]="emergencyInstructionGuideIconType(item)"
                        class="icon-theme"
                        [ngStyle]="{ 'color': selectedThemeColor }"
                        aria-hidden="true"
                        style="margin-right: 8px;"
                      ></span>

                      <span>
                        {{ item.translatedTitle || item.title || ('LANDING.EMERGENCY_INSTRUCTIONS.UNTITLED' | translate) }}
                      </span>
                      <nz-tag
                        *ngIf="item.urgency"
                        [nzColor]="emergencyInstructionUrgencyColor(item.urgency)"
                        style="margin-left: 8px;"
                      >
                        {{ emergencyInstructionUrgencyLabelKey(item.urgency) | translate }}
                      </nz-tag>
                    </ng-template>

                    <div class="instruction-body">
                      <ng-container *ngIf="isEmergencyInstructionV2(item); else legacyEmergencyInstructionTpl">
                        <div *ngIf="(item.translatedSummary || item.summary) as summaryText" class="muted emergency-guide-summary">
                          {{ summaryText }}
                        </div>

                        <div class="emergency-guide-steps">
                          <div class="emergency-guide-step" *ngFor="let step of item.steps || []">
                            <div
                              class="emergency-guide-step__marker"
                              [class.emergency-guide-step__marker--important]="step.urgency === 'important'"
                              [class.emergency-guide-step__marker--critical]="step.urgency === 'critical'"
                            >
                              {{ (step.order || 0) + 1 }}
                            </div>

                            <div class="emergency-guide-step__content">
                              <div class="emergency-guide-step__title">
                                <i
                                  *ngIf="step.iconKey"
                                  nz-icon
                                  [nzType]="resolveEmergencyInstructionIconKey(step.iconKey)"
                                  class="icon-theme"
                                  [ngStyle]="{ 'color': selectedThemeColor }"
                                ></i>
                                <span>{{ step.translatedTitle || step.title }}</span>
                              </div>

                              <div class="emergency-guide-step__description" *ngIf="step.translatedDescription || step.description">
                                {{ step.translatedDescription || step.description }}
                              </div>

                              <ng-container *ngIf="step.action as action">
                                <a
                                  *ngIf="action.type === 'phone' && action.phone"
                                  class="emergency-guide-step__action"
                                  [href]="'tel:' + action.phone"
                                  (click)="trackEmergencyInstructionAction(item, step)"
                                >
                                  {{ action.translatedLabel || action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.PHONE' | translate) }}
                                </a>

                                <a
                                  *ngIf="action.type === 'email' && action.email"
                                  class="emergency-guide-step__action"
                                  [href]="'mailto:' + action.email"
                                  (click)="trackEmergencyInstructionAction(item, step)"
                                >
                                  {{ action.translatedLabel || action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.EMAIL' | translate) }}
                                </a>

                                <a
                                  *ngIf="action.type === 'link' && action.url"
                                  class="emergency-guide-step__action"
                                  [href]="action.url"
                                  target="_blank"
                                  rel="noreferrer"
                                  (click)="trackEmergencyInstructionAction(item, step)"
                                >
                                  {{ action.translatedLabel || action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.LINK' | translate) }}
                                </a>

                                <a
                                  *ngIf="action.type === 'document' && getEmergencyInstructionDocumentUrl(action)"
                                  class="emergency-guide-step__action"
                                  [href]="getEmergencyInstructionDocumentUrl(action)"
                                  [attr.target]="isEmergencyInstructionDocumentImage(action) ? null : '_blank'"
                                  rel="noreferrer noopener"
                                  (click)="onEmergencyInstructionDocumentActionClick($event, item, step, action)"
                                >
                                  {{ action.translatedLabel || action.label || action.document?.fileName || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.DOCUMENT' | translate) }}
                                </a>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-template #legacyEmergencyInstructionTpl>
                        <div *ngIf="(item.translatedWho || item.who) as whoText" class="muted" style="margin-bottom: 8px;">
                          {{ whoText }}
                          <ng-container *ngIf="item.showPhoneNumber && item.phone">
                            ·
                            <a
                              [href]="'tel:' + item.phone"
                              (click)="trackContactClick('phone', item.phone, 'emergency-instruction', item.translatedTitle || item.title)"
                              [ngStyle]="{ 'color': 'inherit', 'text-decoration': 'none' }"
                            >
                              {{ formatGermanPhoneNumber(item.phone) }}
                            </a>
                          </ng-container>
                        </div>

                        <div *ngIf="(item.translatedHow || item.how) as howText">
                          {{ howText }}
                        </div>
                      </ng-template>
                    </div>
                  </nz-collapse-panel>
                </nz-collapse>
              </ng-template>
            </div>

            <!-- Technical Services -->
            <div id="technical-services" class="technical-service-section"
                 *ngIf="hasTechnicalServices"
                 [hidden]="!isEmergencySectionVisible('technical-services')">
              <div class="header-section" [hidden]="showBottomNav && appMode === 'emergency'">
                <div
                  class="logo-container"
                  [class.logo-container--tall]="isEmergencyLogoTall"
                  [class.logo-container--wide]="isEmergencyLogoWide"
                >
                  <img
                    [src]="company?.logoUrl || defaultLogoUrl"
                    (error)="company.logoUrl = defaultLogoUrl"
                    (load)="onEmergencyLogoLoad($event)"
                    alt="Company Logo"
                    class="company-logo-img"
                  />
                </div>
                <div class="header-text">
                  <h2 class="header-title" [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.TECHNICAL_SERVICE' | translate }}</h2>
                  <p class="sub-header">{{ 'COMPANY_PAGE.IMPORTANT_NUMBERS_AT_GLANCE' | translate }}</p>
                </div>
              </div>

              <!-- Display Technical Service Text -->
              <div class="technical-service-text" *ngIf="company?.technicalServiceText">
                <p>{{ translatedTechnicalServiceText || company?.technicalServiceText }}</p>
              </div>

              <nz-collapse
                *ngIf="technicalServiceGroups.length; else noTechnicalServices"
                nzBordered="false"
                nzAccordion
                class="technical-service-collapse"
              >
                <nz-collapse-panel
                  *ngFor="let group of technicalServiceGroups; let i = index"
                  [nzHeader]="('COMPANY_PAGE.TECHNICAL_SERVICE_CATEGORIES.' + group.key) | translate"
                  [nzActive]="i === 0"
                >
                  <div class="ts-group">
                    <ng-container *ngFor="let service of group.services">
                      <ng-container
                        [ngTemplateOutlet]="technicalServiceCard"
                        [ngTemplateOutletContext]="{ $implicit: service }"
                      ></ng-container>
                    </ng-container>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
              <ng-template #noTechnicalServices>
                <div class="technical-service-empty">{{ 'COMPANY_PAGE.TECHNICAL_SERVICE_PREVIEW_EMPTY' | translate }}</div>
              </ng-template>
            </div>

            <div id="quick-links" class="quick-links-section" *ngIf="quickLinks?.length"
                 [hidden]="!isEmergencySectionVisible('quick-links')">
              <div class="quick-links-header">
                <span nz-icon nzType="link" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                <div>
                  <h2 class="header-title" [ngStyle]="{ 'color': selectedThemeColor }">{{ 'COMPANY_PAGE.QUICK_LINKS_TITLE' | translate }}</h2>
                  <p class="sub-header">{{ 'COMPANY_PAGE.QUICK_LINKS_DESCRIPTION' | translate }}</p>
                </div>
              </div>
              <ul>
                <li *ngFor="let link of quickLinks">
                  <span nz-icon nzType="export" class="icon-theme" [ngStyle]="{ 'color': selectedThemeColor }"></span>
                  <a [href]="normalizeUrl(link.url)"
                     target="_blank"
                     rel="noopener"
                     (click)="trackQuickLinkClick(link)">
                    {{ link.translatedLabel || link.label }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Documents Section -->
            <div [attr.id]="prefId('docs')" [hidden]="!isEmergencySectionVisible(prefId('docs'))">
              <app-document-sections
                *ngIf="documentSections?.length || loadingDocs"
                [sections]="documentSections"
                [themeColor]="selectedThemeColor"
                [loading]="loadingDocs"
                [variant]="'emergency'"
                [ngStyle]="showBottomNav && appMode === 'emergency' ? {'--documents-padding':'12px'} : null"
                (sectionView)="trackSectionView($event)"
                (documentView)="trackDocumentView($event.sectionTitle, $event.fileName)"
                (imagePreview)="openImagePreview($event)"
              ></app-document-sections>
            </div>
            <div class="footer-section documents-footer"
                 *ngIf="(!showBottomNav || mobileActiveTab === 'home')
        && !(showBottomNav && appMode === 'emergency' && mobileActiveTab === 'home')
        && company?.website">
              <div class="footer-details">
                <p>
                  <a [href]="normalizeUrl(company.website)" target="_blank" rel="noopener noreferrer">
                    {{ company.website }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Chat widget: ONLY on Hospitality mobile Info dashboard, bubble hidden always -->
        <app-hospitality-chat-widget
          *ngIf="appMode === 'hospitality'
                        && companyId
                        && propertyId
                        && showBottomNav
                        && mobileActiveTab === 'info'
                        && !mobileInfoSectionId"
          [companyId]="companyId"
          [propertyId]="propertyId"
          [selectedLanguage]="selectedLanguage"
          [themeColor]="selectedThemeColor"
          [hideBubble]="true"
        ></app-hospitality-chat-widget>
      </ng-template>
      <!-- ===== Powered by Scanafy (independent footer) ===== -->
      <div
        class="scanafy-powered-by"
        [class.is-mobile]="showBottomNav"
        *ngIf="!loading && !hasError && (!showBottomNav || mobileActiveTab === 'home' || (showBottomNav && appMode === 'emergency' && !mobileInfoSectionId))"
      >
        <a
          class="scanafy-powered-by__link"
          href="https://scanafy.de/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'LANDING.POWERED_BY_SCANAFY' | translate }}
        </a>
      </div>
      <!-- ===== /Powered by Scanafy ===== -->
    </div>
    <!-- Back to dashboard button (shown when a section is selected in Info tab) -->
    <div
      *ngIf="showBottomNav && mobileActiveTab === 'info' && mobileInfoSectionId"
      class="lp-mobile-info__back"
    >
      <button
        *ngIf="showInfoBackButton"
        nz-button
        nzType="primary"
        nzSize="large"
        nzBlock
        nzShape="round"
        class="lp-mobile-info__back-btn"
        (click)="backToDashboard()"
      >
        <i nz-icon nzType="arrow-left" class="lp-mobile-info__back-icon" aria-hidden="true"></i>
        <span class="lp-mobile-info__back-label">
                      {{ (isEmergencyMode ? 'COMMON.BACK_TO_INFO' : 'COMMON.BACK_TO_DASHBOARD') | translate }}
                    </span>
      </button>
    </div>
    <!-- ===== Section Rail (tablet/desktop) ===== -->
    <aside
      class="lp-section-rail"
      *ngIf="showSectionRail && !loading && !hasError"
      [ngClass]="['mode-' + appMode, railCollapsed ? 'is-collapsed' : 'is-expanded']"
    >
      <!-- Collapse / expand toggle -->
      <button
        type="button"
        class="lp-section-rail__toggle"
        (click)="toggleRailCollapsed()"
        [attr.aria-label]="railCollapsed ? ('LANDING.NAV.EXPAND' | translate) : ('LANDING.NAV.COLLAPSE' | translate)"
      >
        <i nz-icon [nzType]="railCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
      </button>

      <!-- Title only when expanded -->
      <div class="lp-section-rail__title" *ngIf="!railCollapsed">
        {{ 'LANDING.NAV.SECTION_MENU_TITLE' | translate }}
      </div>

      <!-- Section buttons: icon always visible; label only when expanded -->
      <button
        class="rail-btn"
        *ngFor="let s of sectionMenu"
        (click)="scrollTo(s.id)"
        [class.active]="activeSectionId === s.id"
        [attr.aria-label]="(s.labelKey | translate)"
        [attr.title]="railCollapsed ? (s.labelKey | translate) : null"
        nz-tooltip
        [nzTooltipTitle]="railCollapsed ? (s.labelKey | translate) : null"
        nzTooltipPlacement="right"
      >
        <i nz-icon [nzType]="s.icon"></i>
        <span class="label" *ngIf="!railCollapsed">{{ s.labelKey | translate }}</span>
      </button>
    </aside>

    <!-- ===== Emergency scroll toast (Home -> nudge to Dashboard) ===== -->
    <!--    <div-->
    <!--            class="lp-dashboard-toast"-->
    <!--            *ngIf="showDashboardToast && showBottomNav && appMode === 'emergency' && mobileActiveTab === 'home' && !loading && !hasError"-->
    <!--            role="status"-->
    <!--            aria-live="polite"-->
    <!--    >-->
    <!--        <div class="lp-dashboard-toast__text">-->
    <!--            {{ 'LANDING.NAV.DASHBOARD_TOAST' | translate }}-->
    <!--        </div>-->

    <!--        <button-->
    <!--                nz-button-->
    <!--                nzType="primary"-->
    <!--                nzSize="small"-->
    <!--                class="lp-dashboard-toast__cta"-->
    <!--                (click)="setMobileTab('info'); dismissInfoTabHint(); stopDashboardAttention(); dismissDashboardToast(true)"-->
    <!--        >-->
    <!--            {{ 'LANDING.NAV.DASHBOARD_TOAST_CTA' | translate }}-->
    <!--        </button>-->

    <!--        <button-->
    <!--                nz-button-->
    <!--                nzType="text"-->
    <!--                nzSize="small"-->
    <!--                class="lp-dashboard-toast__close"-->
    <!--                (click)="dismissDashboardToast(true)"-->
    <!--                [attr.aria-label]="'COMMON.CLOSE' | translate"-->
    <!--        >-->
    <!--            <i nz-icon nzType="close"></i>-->
    <!--        </button>-->
    <!--    </div>-->
    <!-- ===== /Emergency scroll toast ===== -->

    <!-- ===== Bottom Navigation (mobile) ===== -->
    <nav
      class="lp-bottom-nav"
      *ngIf="showBottomNav && !loading && !hasError && appMode !== 'emergency'"
      [ngClass]="'mode-' + appMode"
      role="navigation"
      aria-label="Bottom navigation">
      <button
        type="button"
        class="lp-bottom-nav__item"
        [class.active]="mobileActiveTab === 'home'"
        (click)="setMobileTab('home')"
        [attr.aria-label]="(isEmergencyMode ? 'LANDING.NAV.TAB_HOME_EMERGENCY' : 'LANDING.NAV.TAB_HOME') | translate">
        <i nz-icon [nzType]="isEmergencyMode ? 'bank' : 'home'"></i>
        <span>
                {{ (isEmergencyMode ? 'LANDING.NAV.TAB_HOME_EMERGENCY' : 'LANDING.NAV.TAB_HOME') | translate }}
            </span>
      </button>

      <button
        type="button"
        class="lp-bottom-nav__item"
        [class.active]="mobileActiveTab === 'info'"
        (click)="setMobileTab('info')"
        [attr.aria-label]="(isEmergencyMode ? 'LANDING.NAV.TAB_INFO_EMERGENCY' : 'LANDING.NAV.TAB_INFO') | translate">
        <i nz-icon nzType="appstore"></i>
        <span>{{ (isEmergencyMode ? 'LANDING.NAV.TAB_INFO_EMERGENCY' : 'LANDING.NAV.TAB_INFO') | translate }}</span>
      </button>

      <button
        *ngIf="appMode === 'hospitality' && hospitalityLocalTips"
        type="button"
        class="lp-bottom-nav__item"
        [class.active]="mobileActiveTab === 'map'"
        (click)="setMobileTab('map')"
        [attr.aria-label]="'LANDING.NAV.TAB_MAP' | translate">
        <i nz-icon nzType="environment"></i>
        <span>{{ 'LANDING.NAV.TAB_MAP' | translate }}</span>
      </button>
    </nav>
    <!-- ===== Announcements drawer (opened from bell icon) ===== -->
    <nz-drawer
      [nzVisible]="notificationsDrawerOpen"
      [nzTitle]="'LANDING.ANNOUNCEMENTS.TITLE' | translate"
      nzPlacement="right"
      [nzWidth]="showMobilePreview ? '100%' : '100vw'"
      nzWrapClassName="landing-announcements-drawer"
      [nzClosable]="true"
      (nzOnClose)="onAnnouncementsDrawerClose()"
    >
      <ng-container *nzDrawerContent>
        <div class="landing-announcements">
          <div class="announcements-header">
            <h2>{{ 'LANDING.ANNOUNCEMENTS.TITLE' | translate }}</h2>

            <div class="last-updated" *ngIf="lastAnnouncementUpdated">
              {{ 'LANDING.ANNOUNCEMENTS.LAST_UPDATED' | translate }}
              {{ lastAnnouncementUpdated | date:'short':undefined:selectedLanguage }}
            </div>
          </div>

          <div class="landing-announcements-drawer-body">
            <!-- Loading state -->
            <ng-container *ngIf="announcementsLoading; else announcementsLoaded">
              <nz-spin nzTip="{{ 'LANDING.ANNOUNCEMENTS.LOADING' | translate }}"></nz-spin>
            </ng-container>

            <ng-template #announcementsLoaded>
              <!-- Non-empty list -->
              <ng-container *ngIf="announcements?.length; else announcementsEmpty">
                <ul class="announcement-list">
                  <li
                    *ngFor="let a of announcements"
                    class="announcement-item"
                    [ngClass]="{ urgent: a.urgency === 'urgent' }"
                    role="button"
                    tabindex="0"
                    (click)="openAnnouncement(a)"
                    (keydown)="onAnnouncementItemKeydown($event, a)"
                  >
                    <div class="announcement-headline">
                      <h3>{{ a.translatedTitle || a.title }}</h3>

                      <span *ngIf="a.urgency === 'urgent'" class="urgent-chip">
                    {{ 'LANDING.ANNOUNCEMENTS.URGENT' | translate }}
                  </span>

                      <span *ngIf="a.isNew" class="new-chip">
                    {{ 'LANDING.ANNOUNCEMENTS.NEW' | translate }}
                  </span>
                    </div>

                    <p>{{ a.translatedSummary || a.summary }}</p>

                    <span class="announcement-date">
                  {{ a.updatedAt | date:'short':undefined:selectedLanguage }}
                </span>

                    <div *ngIf="a.attachments?.length" class="announcement-attachments">
                      <h4>{{ 'LANDING.ANNOUNCEMENTS.ATTACHMENTS' | translate }}</h4>

                      <button
                        *ngFor="let file of a.attachments"
                        nz-button
                        nzType="default"
                        type="button"
                        class="announcement-attachment"
                        (click)="$event.stopPropagation(); openAnnouncementAttachment(a, file)"
                      >
                        <span
                          nz-icon
                          [nzType]="isAnnouncementAttachmentImage(file) ? 'file-image' : (file.fileType === 'pdf' ? 'file-pdf' : 'file')"
                        ></span>
                        <span class="announcement-attachment-name">{{ file.fileName }}</span>
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <!-- Empty state -->
              <ng-template #announcementsEmpty>
                <div class="announcements-empty">
                  {{ 'LANDING.ANNOUNCEMENTS.EMPTY' | translate }}
                </div>
              </ng-template>
            </ng-template>

            <!-- Push notification opt-out inside the drawer, at the bottom -->
            <div class="push-opt-out push-opt-out--drawer" *ngIf="showPushOptOut">
              <div class="cta-text">
                {{ 'LANDING.ANNOUNCEMENTS.PUSH_OPT_OUT' | translate }}
              </div>
              <div class="cta-actions">
                <button
                  nz-button
                  nzType="default"
                  nzDanger
                  (click)="disablePush()"
                  [nzLoading]="optOutProcessing"
                  [disabled]="optOutProcessing"
                >
                  {{ 'LANDING.ANNOUNCEMENTS.OPT_OUT' | translate }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </ng-container>
    </nz-drawer>
  </div>
</div>
